import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Icon from 'Pods/Shared/Icon/Icon'

function JobAlert({ url, message, onClose }) {
  return (
    <div className="alert">
      <a href={url} className="alert__link" onClick={onClose}>
        <span dangerouslySetInnerHTML={{ __html: message }} />
      </a>
      <button className="alert__button" onClick={onClose}>
        <Icon type={['far', 'times']} notSpaced />
      </button>
    </div>
  )
}

JobAlert.propTypes = {
  url: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default JobAlert
